import type { CurrentUser } from '@/core/user/models/CurrentUser';
import { CreateUserDTO } from '@/core/admin/DTO/UserToCreateDTO';
import type { User } from '@/core/admin/models/User';
import { container } from 'tsyringe';
import { AdminService } from '@/core/admin/services/AdminServices';
import { DeleteUserDTO } from '@/core/admin/DTO/DeleteUserDTO';
import { UpdateUserDTO } from '@/core/admin/DTO/UpdateUserDto';

export const createUserUseCase = async (currentUser: CurrentUser, user: CreateUserDTO): Promise<User> => {
  const adminService = container.resolve<AdminService>('AdminService');

  return await adminService.createUser(currentUser, user);
};

export const deleteUserUseCase = async (currentUser: CurrentUser, user: DeleteUserDTO): Promise<void> => {
  const adminService = container.resolve<AdminService>('AdminService');
  await adminService.deleteUser(currentUser, user);
};

export const getAllUsersUseCase = async (user: CurrentUser): Promise<User[]> => {
  const adminService = container.resolve<AdminService>('AdminService');

  return await adminService.getAllUsers(user);
};

export const updateUserUseCase = async (currentUser: CurrentUser, user: UpdateUserDTO): Promise<void> => {
  const adminService = container.resolve<AdminService>('AdminService');
  await adminService.updateUser(currentUser, user);
};
